<template>
    <BaseLayout>  
      <ReviewDetail :images="swiperImg" :currObj="onlyData"/> 
    </BaseLayout>
</template>
  
<script> 
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import {mapState} from 'vuex';
import BaseLayout from '@/components/BaseLayout.vue'; 
import ReviewDetail from '@/components/ReviewDetail.vue'; 
import { get } from '@/api/AxiosUtils';
export default { 
    name: 'rincessView',
    components: {
        BaseLayout,  
        ReviewDetail
    },
    data() {
        return {
            // pOnlyObj:{},
            // swiperImg:[],
            productImages: [
                require('@/assets/banner/bg.jpg'),
                require('@/assets/banner/bg2.jpg'),
                require('@/assets/banner/bg2.jpg'),
                require('@/assets/banner/bg.jpg'),
            ],
            p_id:0
        };
    }, 
    computed: {
        ...mapState['princessIndex'], 
    }, 
    setup() { 
        const route = useRoute();
        const pid = ref(route.params.pid); 
        const onlyData = ref(null);
        const swiperImg = ref(null);

        const getFetch = async ()=>{  
            try {
                const url = "/api/princess/getOnly?pid="+pid.value;  
                const response  =  await get(url,{},{});
                if(response.data){
                    let td = response.data[0];
                    onlyData.value = td.desc;
                    let arr =  td.images.split(",");
                    let temparr = [];
                    for (let i = 0; i < arr.length; i++) {
                        temparr.push("https://api2.seattletaotao.com" + arr[i]);
                    }
                    swiperImg.value = temparr;
                    console.log('---revies  ',swiperImg.value)
                }
            }catch (error) { 
                console.error('Network Error:', error); 
            } 
        }
        getFetch();

        onMounted(() => {   
        // 你可以在这里使用 pid 进行其他操作，比如发起 API 请求
        });

        return { 
            onlyData,
            swiperImg,
        }
    },
    // mounted() {
    //     this.getFetch();
    // },
    // methods:{
    //     async getFetch() {    
    //         try {
    //             let si =  this.$route.query;
    //             console.log('---this.pid '+ this.$route.query.pid);
    //             const url = "/api/princess/getOnly?pid="+si; 
    //             // console.log('---url '+ url);
    //             const response  =  await get(url,{},{});  
    //             console.log('---revies  ',response)
    //         }catch (error) {
    //             console.error('Network Error:', error);
    //         }
    //     },
    //     handlData(){
    //         // let _pid = this.$store.state.princessIndex;
    //         // this.pOnlyObj =  this.$store.state.contactList.find(item => {
    //         //     if(item.id == _pid)return item;
    //         // });
    
    //         // let arr = this.pOnlyObj.picimages.split(",");
    //         // let temparr = [];
    //         // for (let i = 0; i < arr.length; i++) {
    //         //     temparr.push("https://api2.seattletaotao.com" + arr[i]);
    //         // }
    //         // this.swiperImg =temparr;
    //     }
    // } 
};
</script>